"use strict";
exports.__esModule = true;
exports.ACTIVITY_ACTION = void 0;
var ACTIVITY_ACTION = {
    ADDED: 'added',
    APPROVED: 'approved',
    CREATED: 'created',
    DELETED: 'deleted',
    INVITED: 'invited',
    LISTED: 'listed',
    READ: 'read',
    SEARCHED: 'searched',
    SUBMITTED: 'submitted',
    SUSPENDED: 'suspended',
    UPDATED: 'updated',
    UPLOADED: 'uploaded'
};
exports.ACTIVITY_ACTION = ACTIVITY_ACTION;
